// extracted by mini-css-extract-plugin
export default {"drops":"AccountDropDown_drops__WQvOI","dropContentCommon":"AccountDropDown_dropContentCommon__x3wLp"};